import React from 'react';
import useRouteChanges from './hooks/useRouteChanges';
import Tooltip from './Tooltip';
import { Gender, GetLeadersResponse } from './types';

interface Props {
  calledBys: GetLeadersResponse['meta']['options']['calledBys'],
}

const selectClasses = [
  'shadow appearance-none border rounded py-1.5 px-2 leading-tight focus:outline-none',
  'text-gray-700 bg-white dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600',
].join(' ');

const Filters = ({ calledBys }: Props) => {
  const {
    calledBy,
    gender,
    setCalledBy,
    setGender,
    showAll,
    toggleShowAll,
  } = useRouteChanges();

  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
      <label className="form-label flex items-center">
        <span className="mr-2">Called By</span>
        <select
          className={`${selectClasses} w-48`}
          name="calledBys"
          onChange={(e) => setCalledBy(e.target.value)}
          value={calledBy}
        >
          <option value="">--</option>
          {calledBys.map(calledBy => <option key={calledBy} value={calledBy}>{calledBy}</option>)}
        </select>
      </label>
      <label className="form-label flex items-center">
        <span className="mr-2">Gender</span>
        <select
          className={`${selectClasses} w-28`}
          name="gender"
          onChange={(e) => {
            setGender(
              (e.target.value === Gender.FEMALE || e.target.value === Gender.MALE)
                ? e.target.value
                : null
            );
          }}
          value={gender || ''}
        >
          <option value="">--</option>
          {Object.values(Gender).map(genderOption => (
            <option
              key={genderOption}
              value={genderOption}
            >
              {genderOption}
            </option>
          ))}
        </select>
      </label>
      <label className="form-label flex items-center">
        <input
          type="checkbox"
          className="h-4 w-4 rounded-full shadow mr-2"
          onChange={toggleShowAll}
          checked={!!showAll}
        />
        <Tooltip caption="Includes outside first presidency and apostles" wide>
          Show All Leaders
        </Tooltip>
      </label>
    </div>
  );
};

export default Filters;
